// Pure layout for FloatingScrollbar: where the proxy bar sits, or null when
// it should not show.
/** The table scroll box's viewport rect (`getBoundingClientRect()`). */
interface ScrollBoxRect {
  top: number;
  bottom: number;
  left: number;
}

export interface FloatingScrollbarLayout {
  left: number;
  width: number;
  /** The scroll box's full content width — the proxy's track spacer. */
  scrollWidth: number;
}

export const floatingScrollbarLayout = ({
  rect,
  clientWidth,
  scrollWidth,
  viewportHeight,
}: {
  rect: ScrollBoxRect;
  clientWidth: number;
  scrollWidth: number;
  viewportHeight: number;
}): FloatingScrollbarLayout | null => {
  // Nothing to scroll sideways. The 1px slack absorbs sub-pixel rounding,
  // which otherwise shows a bar with no travel.
  if (scrollWidth <= clientWidth + 1) return null;
  // The table has not reached the viewport yet — nothing to float over.
  if (rect.top >= viewportHeight) return null;
  // The box's bottom edge, and its native scrollbar, is on screen.
  if (rect.bottom <= viewportHeight) return null;
  // `clientWidth`, not the rect's width: the rect includes the box's vertical
  // scrollbar, and a bar that wide would max out short of the table's scroll
  // range, then pull the table back from its right edge through the sync.
  return { left: rect.left, width: clientWidth, scrollWidth };
};
